module.exports = __webpack_public_path__ + "img/002.2c3ffe11.png";